import { Campaign } from '../../../../../../model/campaign/Campaign';
import CardLayout from '../../../../../../shared/components/card/CardLayout';
import { CustomImageHandler } from '../../../../../../shared/components/CustomImageHandler';
import { formatDate, truncateString } from '../../../../../../shared/functions/Functions';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TooltipOverlay from '../../../../../../shared/components/tooltip/Tooltip';

interface ILinkedCampaignsCardProps {
    campaign: Campaign;
    openBriefingAction: (id: string) => void;
}

export function LinkedCampaignsCard({ campaign, openBriefingAction }: ILinkedCampaignsCardProps) {
    const { t } = useTranslation();
    const title = campaign?.title ?? '';
    const truncatedTitle = truncateString(title, 30);
    const isTruncated = title.length > 30;
    return (
        <div className="my-4">
            <CardLayout classBody="new-cards px-3 py-0">
                <div className="card-row">
                    <div className="image-wrapper">
                        <CustomImageHandler
                            photoPath={campaign?.campaignImages?.[0]?.thumbnail}
                            thumbnailPath={campaign?.campaignImages?.[0]?.thumbnail}
                            altTag="Campaign image"
                        />
                    </div>

                    <div className="card-content">
                        <TooltipOverlay content={isTruncated ? title : ''}>
                            <h6 className="mb-0">{truncatedTitle}</h6>
                        </TooltipOverlay>

                        <p className="mb-0 text-primary">
                            {campaign?.isLongTerm ? (
                                campaign?.date ? (
                                    formatDate(campaign?.date as string)
                                ) : (
                                    'DD.MM.YYYY.'
                                )
                            ) : (
                                <>
                                    {campaign?.publishFrom
                                        ? formatDate(campaign?.publishFrom as string)
                                        : 'DD.MM.YYYY.'}
                                    {' - '}
                                    {campaign?.publishTo ? formatDate(campaign?.publishTo as string) : 'DD.MM.YYYY.'}
                                </>
                            )}
                        </p>
                    </div>

                    <div className="button-wrapper">
                        <Button onClick={() => openBriefingAction(String(campaign?.id ?? 0))} variant="outline-primary">
                            {t('general.button.open')}
                        </Button>
                    </div>
                </div>
            </CardLayout>
        </div>
    );
}
